var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('Search'),_c('Themas'),(_vm.showSelector)?_c('Selector'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }